<template>
    <div class="engineer-customers">
        <div class="engineer-customers__header">
            <h1 class="engineer-customers__title">
                Contacts
            </h1>
            <form
                action=""
                @submit.prevent="search"
                class="engineer-customers__form"
            >
                <input
                    type="search"
                    class="engineer-customers__search-input form-control"
                    placeholder="Search"
                    v-model="keyword"
                    v-debounce:300ms.search="search"
                >
                <button class="engineer-customers__search-btn btn btn-primary">
                    <i class="fa fa-search" />
                </button>
            </form>
        </div>
        <div class="engineer-customers__list">
            <div
                class="engineer-customers__item"
                v-for="customer in customers"
                :key="customer.id"
                @click="goToCustomer(customer)"
            >
                <span class="engineer-customers__item-company">{{ customer.company_name }}</span>
                <span class="engineer-customers__item-name">{{ customer.billing_name }}</span>
                <span class="engineer-customers__item-email">
                    <a
                        :href="'mailto: ' + customer.billing_email"
                        title="Email"
                    >
                        {{ customer.billing_email }}
                    </a>
                </span>
                <span class="engineer-customers__item-phone">
                    <a
                        :href="'tel: ' + customer.billing_telephone"
                        title="Click to call"
                    >
                        {{ customer.billing_telephone }}
                    </a>
                </span>
            </div>
            <button
                v-show="page < lastPage"
                class="engineer-customers__load-more btn btn-primary"
                @click="loadMore"
            >
                Load More
            </button>
        </div>
        <button
            class="engineer-customers__add-btn"
            @click="newCustomer"
        >
            <i class="fa fa-plus" />
        </button>
    </div>
</template>
<script>
import { mapMutations } from 'vuex';
import CustomerService from '../../services/CustomerService';
export default {
    data () {
        return {
            keyword: '',
            loading: false,
            page: 1,
            lastPage: 1,
            customers: [],
        };
    },

    mounted () {
        this.search();
        this.setPageTitle(null);
    },

    methods: {
        ...mapMutations(['setPageTitle']),
        search () {
            this.page = 1;
            this.load();
        },

        load () {
            this.loading = true;
            CustomerService.search({'filter[keyword]': this.keyword, 'page[number]': this.page}).then(res => {
                if (this.page === 1) {
                    this.customers = res.data.data;
                } else {
                    this.customers = this.customers.concat(res.data.data);
                }
                this.lastPage = res.data.last_page;
            });
        },

        loadMore () {
            this.page++;
            this.load();
        },

        newCustomer () {
            this.$router.push({name: 'engineer.customers.new'});
        },

        goToCustomer (customer) {
            this.$router.push({name: 'engineer.customers.show', params: {id: customer.id}});
        }
    },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/engineer/CustomersIndexComponent.vue